/**
 * Deep links into EventPay's Finix dashboard workspace. Superuser-only
 * targets: an organizer has no login there, and sandbox ids never resolve.
 */
const FINIX_DASHBOARD_URL =
  'https://finix.payments-dashboard.com/Dashboard/APICREDkSo9cUpUcvEAQLNinUZejA'

/** The payments list; append a transfer id (TRxxx) for one charge. */
export const FINIX_DASHBOARD_PAYMENT_URL = `${FINIX_DASHBOARD_URL}/payments`

/** The dashboard page for one transfer, or null when the id is not a Finix one. */
export function finixPaymentUrl(transferId?: string | null): string | null {
  const id = (transferId ?? '').trim()
  return id.startsWith('TR') ? `${FINIX_DASHBOARD_PAYMENT_URL}/${id}` : null
}

/** The dashboard page for one payment instrument (PIxxx), or null. */
export function finixInstrumentUrl(instrumentId?: string | null): string | null {
  const id = (instrumentId ?? '').trim()
  return id.startsWith('PI') ? `${FINIX_DASHBOARD_URL}/payment-instruments/${id}` : null
}

/** The dashboard page for one dispute (DIxxx), or null. */
export function finixDisputeUrl(disputeId?: string | null): string | null {
  const id = (disputeId ?? '').trim()
  return id.startsWith('DI') ? `${FINIX_DASHBOARD_URL}/disputes/${id}` : null
}
